export default __webpack_public_path__ + "0b58123438bf08050ea73c721883e810.svg";